<template>
  <div class="mine page">
    <div class="page-bg"></div>
    <div class="wrapper">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :loading-text="$t('加载中')" :pulling-text="$t('下拉即可刷新')"
        :loosing-text="$t('释放即可刷新')">
          <div style="height:42vw"></div>
        <div class="header">
          <van-nav-bar class="nav-bar">
            <template #right>
              <!-- <van-icon name="setting-o" @click="showSetting()" color="#fff"/> -->
              <van-icon name="chat-o" @click="$router.push({ path: '/ServiceOnline' });" color="#fff" />
            </template>
          </van-nav-bar>
          <div style="height:20px"></div>
          <div class="user-wrapper" @click="doLogin()">
            <!-- <van-image round class="user_img" src="http://kongh5.haiwaiym18.top/img/avatar.b93a1df3.png">
               <template v-slot:loading>
                 <van-loading type="spinner"/>
               </template>
             </van-image> -->
            <van-image round class="user_img" :src="userInfo.header_img ? userInfo.header_img : '/img/image/mine.png'">
              <template v-slot:loading>
                <van-loading type="spinner" />
              </template>
            </van-image>
            <div class="login-content">
              <div class="login-btn">{{ this.userInfo.username }}</div>
              <div class="login-btn" style="font-size: 15px !important;">{{ this.$t('信誉分') }} <b>:</b> {{ userInfo.credit_score }}</div>
            </div>
          </div>
        </div>
        <div class="content">
          <div class="finance">
            <!-- @click="toService()" -->
            <div class="finance-item" @click="doWithdrawal()">
              <van-icon class="icon" style=""
                name="data:image/png;base64,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" />
              <span class="text">{{ $t("my.withdraw") }}</span>
            </div>

            <!-- <div class="finance-item"  @click="doWithdrawal()">
              <van-icon class="icon" name="idcard" />
              <span class="text">{{$t("my.withdraw")}}</span>
            </div> -->
          </div>

          <div class="wallet">
            <div class="part-1 van-hairline--bottom">
              <p class="flex-1 font-28 font-primary-color">{{ $t("my.activity_points") }}</p>

            </div>
            <div class="part-2">
              <p class="balance van-ellipsis"></p>
              <!-- <span class="font-28 font-gray">{{$t("my.balance")}}({{$t("reservation.unit")}})</span> -->
              <span class="font-28 font-gray">{{ $t("reservation.unit") }}</span>
              <div class="refresh-btn" @click="refresh()"><van-icon name="replay" /></div>
            </div>
            <div class="part-2 part-3">
              <p class="balance van-ellipsis">{{ this.userInfo.money }}</p>
              <!-- <span class="font-28 font-gray">{{$t("my.balance")}}({{$t("reservation.unit")}})</span> -->

            </div>
          </div>

          <div :style="{ marginTop: menu_top + 'px' }" class="menu">
            <div class="menu-item" @click="$router.push({ path: '/Infomation' });">
              <van-image class="menu-item-icon" src="/img/mine/nav1.png">
                <template v-slot:loading>
                  <van-loading type="spinner" />
                </template>
              </van-image>
              <span class="menu-item-label">{{ $t("my.basic_information") }}</span>
            </div>
            <div class="menu-item" @click="$router.push({ path: '/SetLoginPassword' });">
              <van-image class="menu-item-icon" src="/img/mine/nav7.png">
                <template v-slot:loading>
                  <van-loading type="spinner" />
                </template>
              </van-image>
              <span class="menu-item-label">{{ $t("my.Login_password") }}</span>
              <!-- <span class="menu-item-label" >{{$t("my.account_detail")}}</span> -->
            </div>
            <div class="menu-item" @click="$router.push({ path: '/GameRecord' });">
              <van-image class="menu-item-icon" src="/img/mine/baobiao.png">
                <template v-slot:loading>
                  <van-loading type="spinner" />
                </template>
              </van-image>
              <span class="menu-item-label">{{ $t("my.task_log") }}</span>
            </div>
            <div class="menu-item" @click="toNotice()">
              <van-image class="menu-item-icon" src="/img/mine/4.png">
                <template v-slot:loading>
                  <van-loading type="spinner" />
                </template>
              </van-image>
              <span class="menu-item-label">{{ $t("my.sys_notice") }}</span>
            </div>
            <div class="menu-item" @click="toService">
              <van-image class="menu-item-icon" src="/img/mine/5.png">
                <template v-slot:loading>
                  <van-loading type="spinner" />
                </template>
              </van-image>
              <span class="menu-item-label">{{ $t("my.online_customer_service") }}</span>
            </div>
            <!-- <div class="menu-item" @click="toService()">
                <van-image class="menu-item-icon" src="img/mine/kefu_1.svg">
                  <template v-slot:loading>
                    <van-loading type="spinner"/>
                  </template>
                </van-image>
                <span class="menu-item-label" >{{$t("my.online_service")}}</span>
              </div> -->
          </div>
          <div class="btn">
            <van-button color="linear-gradient(90deg,#6529c9,#cc2996)"
              style="margin: 20px 0;font-size: 16px;padding:25px 0;width: 100%;border-radius: 14px;"
              @click="loginout()">
              {{ $t("setting.logout") }}
            </van-button>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      userInfo: {
      },
      menu_top: 40,
      isLoading: false,
      timeOut:null
    };
  },
  methods: {
    refresh() {
      this.isLoading = true;
      this.getUserInfo(1);
    },
    exit() {
      this.$toast(this.$t("my.finish_task"));
    },
    showSetting() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Setting' })
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    toNotice() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Notice' })
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.getUserInfo();
          this.$toast(this.$t("reservation.refresh"));
        } else {
          this.$router.push({ path: '/Login' })
        }
      }, 500);
    },
    doLogin() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Infomation' });
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    doPay() {
      this.$router.push({
        name: 'Recharge',
        params: {
          'balance': this.userInfo.money
        }
      })
    },
    doWithdrawal() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.data.is_bank) {
          this.$router.push("withdraw");
        } else {
          this.$router.push("Setbank");
          this.$toast.fail(this.$t("setting.set_bank"));
        }
      })
    },
    toService() {
      const service = this.$store.getters.getBaseInfo;
      if (service.iskefu == 1){
        window.location.href = service.kefu
      }
    },
    getUserInfo(type) {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          if (type === 1) {
            this.isLoading = false;
            setTimeout(() => {
              this.$toast(this.$t("reservation.refresh"));
            }, 500)
          }
          this.$set(this, 'userInfo', res.data)
          this.menu_top = 15;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear()
            this.$router.push({ path: '/Login' })
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    loginout() {
      localStorage.clear()
      this.$router.push({ path: '/Login' });
    }
  },
  created() {
    if (localStorage.getItem('token')) {
      this.getUserInfo();
      this.timeOut = setInterval(() => {
        this.getUserInfo();
      }, 8000)
    } else {
      this.userInfo.username = this.$t("setting.log_reg");
      this.userInfo.ip = this.$t("setting.more_service");
      this.userInfo.header_img = "img/mine/avatar.png";
    }
  },
  beforeDestroy() {
    // 组件销毁前（离开页面时）销毁定时器
    clearInterval(this.timeOut)
    this.timeOut = null
  }
};
</script>

<style scoped>
.page {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  background-color: #f2f2f5;
}

.mine {
  position: relative;
  bottom: 20px;
  background: #f2f2f5;
  background: url('/img/usertop.660cec17.png') no-repeat top -16vw center;
  background-size: contain;
  padding-bottom: 7vw;
}

.mine .wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.nav-bar {
  /* background: linear-gradient(
      90deg,#7e5678,#e6c3a1); */
  background: content-box;
}

.mine .header {

  padding-bottom: 100px;
  background-size: contain
}

::v-deep .van-nav-bar__content {
  height: 100px;
}

::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0px;
}

.mine .header .van-nav-bar .van-icon {
  font-size: 45px;
}

.mine .header .user-wrapper {
  display: flex;
  align-items: center;
  margin: 0px 40px 0px 40px;

}

.mine .user_img {
  height: 130px;
  width: 130px;
}

::v-deep .van-loading__spinner {
  height: 50px;
  width: 50px;
}

::v-deep .van-image__error-icon {
  font-size: 70px;
}

.mine .header .user-wrapper .login-content {
  flex: 1;
  margin-left: 30px;
  display: flex;
  flex-direction: column;
}

.mine .header .user-wrapper .login-content .login-btn {
  display: inline-block;
  font-size: 40px;
  color: #fff;
}

.mine .header .user-wrapper .login-content .login-label {
  margin-top: -13px;
  font-size: 28px;
  color: hsla(0, 0%, 100%, .6);
}

.mine .page-bg {
  height: 500px;

}

.mine .content {
  position: relative;
  padding: 10px 30px 30px;
  min-height: 500px;
  background-color: #f2f2f5;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #ffffff;
  font-size: 35px;
}

.mine .wrapper .content .finance {
  position: absolute;
  display: flex;
  align-items: center;
  top: -55px;
  left: 30px;
  right: 30px;
  height: 120px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}

.mine .wrapper .content .finance .line {
  width: 3px;
  height: 40px;
  background-color: #ccc;
}

.mine .wrapper .content .finance .finance-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.mine .wrapper .content .finance .finance-item .text {
  margin-left: 30px;
  font-size: 30px;
  color: #000;
  font-weight: 500;
}

.mine .wrapper .content .finance .finance-item .icon {
  font-size: 50px;
}

.mine .wrapper .content .menu {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}

.mine .wrapper .content .menu .menu-item {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 33.3%;
  height: 180px;
}

.mine .wrapper .content .menu .menu-item .menu-item-label {
  font-size: 24px;
  color: #432788;
  font-weight: 500;
}

.mine .wrapper .content .menu .menu-item .menu-item-icon {
  margin: 25px;
  width: 60px;
  height: 60px;
  -o-object-fit: contain;
  object-fit: contain;
}

.mine .wrapper .content .wallet {
  margin-top: 80px;
  padding: 0 30px;
  background-color: #a06098;
  border-radius: 15px;

  box-shadow: 0 1.5px 1px 0 #e4e4e7;
}

.mine .wrapper .content .wallet .part-1 {
  display: flex;
  align-items: center;
  height: 100px;
}

.mine .wrapper .content .wallet .font-primary-color {
  color: #fff;
  font-size: 32px;
}

.font-gray {
  color: #fff;
  font-size: 28px;
}

.mine .wrapper .content .wallet .part-2 {
  display: flex;
  align-items: center;
  height: 10px;
}

.mine .wrapper .content .wallet .part-3 {
  display: flex;
  align-items: center;
  height: 80px;
}

.mine .wrapper .content .wallet .part-2 .balance {
  flex: 1;
  font-size: 60px;
  color: #fff;
  font-weight: 700;
}

/* .mine .wrapper .content .wallet .van-hairline--bottom::after {
  border-bottom-width: 3px;
} */
.mine .wrapper .content .wallet .part-2 .refresh-btn {
  margin-left: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  font-size: 30px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #e6c3a1;
}

.btn {
  margin: 40px 0;
}
</style>
